<template>
  <div id="privacy-page" class="terms-content">
    <article-generator :title="PRIVACY.title" :content="PRIVACY.content" />
  </div>
</template>

<script setup lang="ts">
import articleGenerator from '@/components/common/article-generator.vue'

import { ArticleContentStructureType } from '@/types/article-generator'

definePageMeta({
  layout: 'terms',
  middleware: ['check-region'],
})

const { t } = useI18n()

const PRIVACY = computed(() => ({
  title: t('footer_privacy_policy'),
  content: [
    {
      type: ArticleContentStructureType.HTML,
      content: t('privacy_policy_content'),
    },
  ],
}))
</script>

<style lang="scss" scoped></style>
